/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import parseV3000SumFormula from '@Utils/React/MolFiletoFormula';

import AlertStructuresButton from './AlertStructuresButton';

function AlertStructuresInDescription(props) {
  const { structures } = props;

  if (!structures || structures.count() === 0) {
    return null;
  }

  return structures.map((structure, index) => (
    <AlertStructuresButton
      {...props}
      key={`${index}-${structure.get('id')}`}
      id={structure.get('id')}
      structureInfo={structure}
      formula={parseV3000SumFormula(structure.get('structure'))}
    />
  ));
}

AlertStructuresInDescription.propTypes = {
  structures: PropTypes.instanceOf(List),
};

export default AlertStructuresInDescription;
